import React from 'react';
import CheckboxInput from './CheckboxInput';

/**
 * Used to manage this component in the BootstrapTable
 */
class ActiveEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            warrantyId: props.row.warrantyId,
            selected: props.row.isActive
        };
    }

    focus = () => {
    }

    onToggleRegion = (event) => {
        this.setState(Object.assign({}, this.state, { selected: event.target.value }));
    }

    updateData = () => {
        this.props.onUpdate(this.state.selected);
    }

    render() {
        return (
            <center> < CheckboxInput name={'garanzia_' + this.state.warrantyId + '_isActive'} label='' value={this.state.selected} onChange={this.onToggleRegion} />
                <button
                    className='btn btn-info btn-xs textarea-save-btn'
                    onClick={this.updateData}>
                    Aggiorna </button>
            </center>
        );
    }
}

export default ActiveEditor;
